(function () {
  function killSticky() {
    if (window.innerWidth > 749) return;

    var selectors = [
      'body.template-product #section-product',
      'body.template-product #section-product.box--can-stick',
      'body.template-product #section-product.sticky-because',
      'body.template-product #section-product .site-box-container',
      'body.template-product #section-product .site-box-content',
      'body.template-product #section-product .product-gallery--sticky',
      'body.template-product #section-product .is-sticky'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function (el) {
      el.classList.remove('is-sticky', 'product-gallery--sticky', 'sticky-because', 'box--can-stick');
      el.style.position = 'static';
      el.style.top = 'auto';
      el.style.bottom = 'auto';
      el.style.transform = 'none';
    });
  }

  document.addEventListener('DOMContentLoaded', killSticky);
  window.addEventListener('resize', killSticky);
  setTimeout(killSticky, 300); // helps if theme/app applies sticky after load
})();